export class privacyCMSModel {
    privacypolicy: any;
}


export class privacyEntryIdObj {
  	entryIds = [
      { id:'7hhoCnZEjCmSSBtFGd9lb1', text : 'privacypolicy'}
  	];
}